/**
 * Everything brand-specific — palette, mark, wordmark, copy, assets — resolves
 * from here, so no screen ever hardcodes a colour or a name.
 */
export interface Brand {
  readonly id: string
  /** Lowercase wordmark as it is set in the lockup. */
  readonly wordmark: string
  /** Capitalised name for prose and the document title. */
  readonly name: string
  readonly tagline: string
  readonly description: string
  /** Asset path inside the R2 bucket. */
  readonly mark: string
  /** Width ÷ height of the mark, so the lockup never distorts. */
  readonly markRatio: number
  readonly authPanel: string
  readonly authHeadline: string
  readonly authSubhead: string
  readonly themeColor: string
  /** Email domain used in mock data and placeholders. */
  readonly domain: string
}

export const BRAND: Brand = {
  id: 'pass',
  wordmark: 'pass',
  name: 'Pass',
  tagline: 'money that moves at the speed of you',
  description:
    'Spend, send and hold dollars from one account. Local details in four currencies, a card that works everywhere, and a price you can read.',
  mark: 'logo/pass-mark.svg',
  markRatio: 253.74 / 343.35,
  authPanel: 'brand/auth-panel.jpg',
  authHeadline: 'Money that moves at the speed of you.',
  authSubhead:
    'Spend, send and hold dollars from one account, with local details in four currencies.',
  themeColor: '#0b0b0f',
  domain: 'pass.com',
}
